module.exports = __webpack_public_path__ + "img/heart_significance.bba2508f.png";